import React, { FunctionComponent } from 'react';
import { Accordion, AccordionDetails, Typography, Grid, AccordionSummary, Divider, FormControl, FormLabel, List, ListItem, ListItemIcon, Checkbox, ListItemText, ThemeProvider } from '@material-ui/core';
import styles from "./MsClaimDetailSummary.Styles";
import { EmptyDataLabel } from '../../../generic-components/empty-data-label/EmptyDataLabel.Component';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import StateEntity from '../../../../entities/State.Entity';
import ReferralClaimEntity from '../../../../entities/ReferralClaim.Entity';
import CoverageTypeEntity from '../../../../entities/CoverageType.Entity';
import Moment from 'moment';

interface IMsClaimDetailSummaryProps {
    referralClaim: ReferralClaimEntity;
    states: Array<StateEntity>;
    coverageTypes: Array<CoverageTypeEntity>;
}

export const MsClaimDetailSummary: FunctionComponent<IMsClaimDetailSummaryProps> = (props: IMsClaimDetailSummaryProps) => {
    const classes = styles();

    var claimCoverageType = props.coverageTypes?.filter(x => !!props.referralClaim && !!props.referralClaim.coverageTypeId && x.coverageTypeId == props.referralClaim.coverageTypeId);

    return (
        <Accordion defaultExpanded={true} className={classes.paper} square>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon className={classes.paperHeaderIcon} />}
                aria-controls="panel1a-content"
                id="cliam-accordion"
                className={classes.paperHeader}
            >
                <Typography variant="subtitle2" className={classes.paperTitle}>Claim</Typography>
            </AccordionSummary>
            <AccordionDetails>
                {
                    props.referralClaim ?
                        <Grid container spacing={3} className={classes.gridContainer}>
                            <Grid item xs={3}>
                                <Typography variant="body2" className={classes.dataLabel}>Claim Number</Typography>
                                <Typography variant="subtitle2" className={classes.blackFont}>{props.referralClaim.claimNumber}</Typography>
                            </Grid>
                            <Grid item xs={3}>
                                <Typography variant="body2" className={classes.dataLabel}>Date Of Loss</Typography>
                                <Typography variant="subtitle2" className={classes.blackFont}>{Moment(props.referralClaim.dateOfLoss).format('MM/DD/YYYY')}</Typography>
                            </Grid>
                            <Grid item xs={3}>
                                <Typography variant="body2" className={classes.dataLabel}>Coverage Type</Typography>
                                <Typography variant="subtitle2" className={classes.blackFont}>{claimCoverageType[0]?.coverageTypeCode + ' - ' + claimCoverageType[0]?.coverageTypeName}</Typography>
                            </Grid>
                            <Grid item xs={3}>
                                <Typography variant="body2" className={classes.dataLabel}>State Of Jurisdiction</Typography>
                                <Typography variant="subtitle2" className={classes.blackFont}>{props.states?.filter(x => !!props.referralClaim && !!props.referralClaim.stateOfJurisdictionId && x.stateId == props.referralClaim.stateOfJurisdictionId)[0]?.stateName}</Typography>
                            </Grid>
                            <Grid item xs={3}>
                                <Typography variant="body2" className={classes.dataLabel}>Claim Type</Typography>
                                <Typography variant="subtitle2" className={classes.blackFont}>{props.referralClaim.claimType?props.referralClaim.claimType : ""}</Typography>
                            </Grid>
                            <Grid item xs={3}>
                                <Typography variant="body2" className={classes.dataLabel}>Claim Status</Typography>
                                <Typography variant="subtitle2" className={classes.blackFont}>{props.referralClaim.claimStatus?props.referralClaim.claimStatus : ""}</Typography>
                            </Grid>
                            <Grid item xs={3}>
                                <Typography variant="body2" className={classes.dataLabel}>Date the claim was closed</Typography>
                                <Typography variant="subtitle2" className={classes.blackFont}>{props.referralClaim.closedDate ? Moment(props.referralClaim.closedDate).format('MM/DD/YYYY') : "" }</Typography>
                            </Grid>
                            <Grid item xs={3}>
                                <Typography variant="body2" className={classes.dataLabel}>Date claim became medical only </Typography>
                                <Typography variant="subtitle2" className={classes.blackFont}>{props.referralClaim.medicalDate ? Moment(props.referralClaim.medicalDate).format('MM/DD/YYYY') : "" }</Typography>
                            </Grid>
                            <Grid item xs={3}>
                                <Typography variant="body2" className={classes.dataLabel}>Date claim became lost time</Typography>
                                <Typography variant="subtitle2" className={classes.blackFont}>{props.referralClaim.lostTimeDate ? Moment(props.referralClaim.lostTimeDate).format('MM/DD/YYYY') : "" }</Typography>
                            </Grid>
                        </Grid>
                        :
                        <EmptyDataLabel></EmptyDataLabel>
                }
            </AccordionDetails>
        </Accordion>
    );
}